import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  ResendVerifyEmailEffectActions,
  VerifyEmailPageActions,
} from './resend-verify-email.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { ResendVerifyEmailService } from './resend-verify-email.service';

@Injectable()
export class ResendVerifyEmailEffects {
  resendVerifyEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VerifyEmailPageActions.resendEmailClicked),
      exhaustMap(({ userId }) =>
        this.resendVerifyEmailService.resendVerifyEmail(userId).pipe(
          map(() => ResendVerifyEmailEffectActions.resendEmailSucceeded()),
          catchError(({ error: responseBody }: HttpErrorResponse) =>
            of(
              ResendVerifyEmailEffectActions.resendEmailErrored({
                error: responseBody.error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private resendVerifyEmailService: ResendVerifyEmailService,
  ) {}
}
